module.exports = __webpack_public_path__ + "img/8.cddf7ae6.png";